module.exports = __webpack_public_path__ + "static/media/breaking_bad_logo.5301e56e.svg";